import {
  TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';
import { AsyncThunk } from '@reduxjs/toolkit';
import get from 'lodash/get';
import { RequestStatus } from '@Hotels-at-Home/hah-fe-core/dist/types';
import type { AppDispatch, RootState } from './index';

export const useDispatch = () => useReduxDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

// get loading status for the corresponding thunk
export const useGetLoadingStatus = <TReturned, TThunkArg, TThunkApiConfig>(
  thunk: AsyncThunk<TReturned, TThunkArg, TThunkApiConfig>,
): boolean => {
  const selectIsLoading = (state: RootState) => {
    const { typePrefix } = thunk;
    const typePrefixSplitted = typePrefix.split('/');

    const sliceName = get(typePrefixSplitted, [0], '');
    const thunkName = get(typePrefixSplitted, [1], '');

    return get(state, [sliceName, 'requestStatuses', thunkName]) === RequestStatus.Pending;
  };

  return useSelector(selectIsLoading);
};
